export default __webpack_public_path__ + "static/media/properties.6adfd7c3.jpg";